import moment from 'moment-timezone';

const calculateCurrentTimeWithOffset = ({ number, unit }) => {
  const now = moment();
  if (!number || !unit) return now;

  return now.add(parseInt(number, 10), unit);
};

export default calculateCurrentTimeWithOffset;
